import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/services/api/api.service';
import { ModalService } from '../modal.service';
import { CoreTranslateService } from 'src/app/services/utilitys/utilitys.service';

@Component({
  selector: 'app-modal-market-store-create',
  templateUrl: './modal-market-store-create.component.html',
  styleUrls: ['./modal-market-store-create.component.scss']
})
export class ModalMarketStoreCreateComponent implements OnInit {

  @ViewChild('marketStoreCreateModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  step = 1;
  errorMsg: any = '';
  customStoreModel: any = {};
  productModel: any = {};
  categorys: any = [];
  image: any;
  conditionText: any = '';
  callback: Function;
  isAccept = false;
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private api: ApiService,
    private ngxLoading: NgxUiLoaderService,
    private coreTranslate: CoreTranslateService
  ) { 
  }

  ngOnInit() {
    this.modalServ.onMarketStoreCreate.subscribe(req => {
      this.step = 1;
      this.getMarketPlaceCategory();
      this.getConditionTerms();
      this.callback = req.callback;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onMarketStoreCreateHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  getMarketPlaceCategory() {
    this.api.getMarketPlaceCategory(false).subscribe(res => {
      if (res.Code == 200) {
        this.categorys = res.Results;
      } else {
        console.error(res);
      }
    }, err => {
      console.error(err);
    });
  }

  showConditionInfo() {
    this.modalServ.onMarketTermcondition.emit({title: this.coreTranslate.getWord('PRODUCT.STORE_REGISTRATION_CONDITIONS'), content: this.conditionText, callback: ()=> {}});
  }

  fileChangeImgStore(event: any) {
    // this.hide();
    this.modalServ.onImageCapture.emit({image: event, callback: (res)=>{
      if(res){
        this.customStoreModel.image = res;
      }
    }});
  }

  fileChangeEvent(event: any) {
    // this.hide();
    this.modalServ.onImageCapture.emit({image: event, callback: (res)=>{
      if(res) {
        if(!this.productModel.hasOwnProperty('imageProducts')) {
          this.productModel.imageProducts = [];
        }
        this.productModel.imageProducts.push({Url: res, IsDefault: false});
      }
      
      // this.modalRef = this.modalService.show(this.modal, this.configmodal);
    }});
  }

  get storeInvalid() {
    if (Object.keys(this.customStoreModel).length === 0) {
      return false;
    } else if(!this.customStoreModel.merch_name) {
      return false;
    } else if (!this.customStoreModel.prod_cat) {
      return false;
    } else if (!this.customStoreModel.phone_number) {
      return false;
    }

    return true;
  }

  validation() {
    if (Object.keys(this.customStoreModel).length === 0) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_FILL_ALL_INFORMATION');
      return false;
    } else if(!this.customStoreModel.merch_name) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_STORE_PICTURE');
      return false;
    } else if (!this.customStoreModel.merch_cat) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PRODUCT_TYPE');
      return false;
    } else if (!this.customStoreModel.phone_number) {
      this.errorMsg = this.coreTranslate.getWord('PROFILE.PLEASE_FILL_PHONE_NUMBER');
      return false;
    }

    return true;
  }

  openEditImage(index: any) {
    // this.hide();
    this.modalServ.onImageCapture.emit({imgFile: this.productModel.imageProducts[index].Url, callback: (res)=>{
      if(res) {
        this.productModel.imageProducts[index] = {Url: res, IsDefault: this.productModel.imageProducts[index].IsDefault};
      }
      // this.modalRef = this.modalService.show(this.modal, this.configmodal);
    }});
  }

  removeImageProduct(index: any) {
    this.productModel.imageProducts.splice(index, 1);
  }

  viewImage(index: any) {
    this.modalServ.onImageViewer.emit({image: this.productModel.imageProducts[index].Url});
  }

  setImageDefulte(img: any) {
    this.productModel.imageProducts.forEach((g: any) => {
      g.IsDefault = false;
    });
    img.IsDefault = true;
  }

  validateMoney(value: any) {
    let pattern = /[0-9]/g;
    let w = pattern.test(value.value);
    if(!w) {
      value.value = null;
    }
  }

  get productInvalid() {
    if (Object.keys(this.productModel).length === 0) {
      return false;
    } else if(!this.productModel.hasOwnProperty('imageProducts') || this.productModel.imageProducts.length < 1) {
      return false;
    } else if (!this.productModel.prod_name) {
      return false;
    } else if (!this.productModel.prod_cat) {
      return false;
    } else if ((this.productModel.prod_price || this.productModel.prod_price === 0 ? false : true) || this.productModel.prod_price < 0) {
      return false;
    }

    return true;
  }

  productValidation() {
    if (Object.keys(this.productModel).length === 0) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_FILL_ALL_INFORMATION');
      return false;
    } else if(!this.productModel.hasOwnProperty('imageProducts') || this.productModel.imageProducts.length < 1) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_AT_LEAST_1_PRODUCT_PICTURE');
      return false;
    } else if (!this.productModel.prod_name) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PRODUCT_NAME');
      return false;
    } else if (!this.productModel.prod_cat) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PRODUCT_TYPE');
      return false;
    } else if ((this.productModel.prod_price || this.productModel.prod_price === 0 ? false : true) || this.productModel.prod_price < 0) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PRODUCT_PRICE');
      return false;
    }

    return true;
  }

  getConditionTerms() {
    this.api.getMarketPlaceConditionTerms().subscribe(res => {
      if (res.Code === 200) {
        this.conditionText = res.Results;
      } else {
        console.error(res);
      }
    }, err => {
      console.error(err);
    });
  }

  confirm() {
    if(!this.productValidation()) return;
    if(!this.validation()) return;

    this.modalServ.onConfirm.emit({title: this.coreTranslate.getWord('ACTIVITIES.CONFIRM'), content: this.coreTranslate.getWord('PRODUCT.CONFIRM_REGISTER_A_STORE'), callback: res=> {
      if(res.status == 'confirm') {
        this.registerStore();
      }
    }});
  }

  registerStore() {
    let body = {...this.productModel, ...this.customStoreModel};
    this.ngxLoading.start();
    this.api.marketPlaceRegisterStore(body).subscribe(res => {
      this.hide();
      this.ngxLoading.stopAll();
      if (res.Code === 200) {
        this.callback({status: 'success'});
        let msg = this.coreTranslate.getWord('PRODUCT.PLEASE_WAIT_FOR_THE_ADMIN_APPROVED') + '' + this.coreTranslate.getWord('PRODUCT.YOU_WILL_RECEIVE_A_NOTIFICATION_WHEN_YOUR_STORE') + '' + this.coreTranslate.getWord('PRODUCT.HAS_BEEN_APPROVED');
      } else {
        console.error(res);
        this.callback({status: 'danger'});
        this.hide();
        this.ngxLoading.stopAll();
      }
    }, err => {
      this.callback({status: 'danger'});
      this.hide();
      this.ngxLoading.stopAll();
      console.error(err);
    });
    
    // console.log(body);
  }

}
